var React = require('react');

function Trashcan (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"points":"3 6 5 6 21 6","key":0}),React.createElement("path",{"d":"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2","key":1}),React.createElement("line",{"x1":"10","y1":"11","x2":"10","y2":"17","key":2}),React.createElement("line",{"x1":"14","y1":"11","x2":"14","y2":"17","key":3})]);
}

Trashcan.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-trash-2"};

module.exports = Trashcan;

Trashcan.default = Trashcan;
